import { useCurrentProjectId } from '@adsk/alloy-provider';
import { useNotifications, NOTIFICATION_STATUSES } from '@adsk/alloy-react-notification';
import { LinkButton } from '@adsk/alloy-react-button';
import { T } from '../helpers/i18n';
import { getProjectUrl } from '../helpers/urlHelpers';

const useRfiNotifications = () => {
  const projectId = useCurrentProjectId();

  const { showNotification } = useNotifications();

  const showSuccessNotification = (rfi: any) => {
    const rfiDeepLink = `${getProjectUrl(projectId as string)}?preview=${rfi.id}`;
    const linkText = rfi.customIdentifier || T.translate('Unspecified');
    showNotification({
      status: NOTIFICATION_STATUSES.SUCCESS,
      message: T.translate('new.alert.created', {
        link1: <LinkButton onClick={() => window.open(rfiDeepLink)}>{linkText}</LinkButton>,
      }),
    });
  };

  const showErrorNotification = () => {
    showNotification({
      status: NOTIFICATION_STATUSES.ERROR,
      message: T.translate('new.error.general'),
    });
  };

  return { showSuccessNotification, showErrorNotification };
};

export default useRfiNotifications;
